import axios from "axios";
import BaseWebService from "./base_web_service";
import DOMPurify from "dompurify";

class DocumentWebService {

  static getMrttBusinessContextPath() {
    return "/mrtt/prubsn/api/v1";
  }

  static async getPdfByCode(id, docCode) {
    let header = await BaseWebService.standardHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/proposal/${docCode}?proposalId=${id}`);
    let resp = await axios.get(
      url,
      {
        headers: header,
        // responseType: 'blob',
      }
    );
    return resp;
  }

  static async getPrivayPolicySummaryByCode(pdf_code) {
    let header = await BaseWebService.standardHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/asset/${pdf_code}`);
    let resp = await axios.get(
      url,
      {
        headers: header,
        // responseType: 'blob',
      }
    );
    return resp;
  }

  static async getPdfProposalByCode(id, docCode) {
    let header = await BaseWebService.standardHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/proposal/${docCode}?proposalId=${id}`);
    let resp = await axios.post(
      url,
      {},
      {
        headers: header,
        // responseType: 'blob',
      }
    );
    return resp;
  }

  static async deleteUploadDocs(payload) {
    let header = await BaseWebService.standardHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_CMS}/record/delete/template?code=delete_uploaded_document_file`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);

    return response;
  }

  static async saveUploadDocs(entity, payload) {
    let header = await BaseWebService.standardHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/proposal/${entity}`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);

    return response;
  }

  static async getUploadDocsById(code, payload) {
    let header = await BaseWebService.standardHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_CMS}/record/read/template?code=${code}`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);

    return response;
  }
  
  static async getMrttDocsById(code, payload) {
    console.log("checkingg", payload)
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_NEW_URL}/template?code=${code}`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    console.log("docccc", resp)
    let response = BaseWebService.standardResponseFromWeb(resp.data);

    return response;
  }

  static async getUploadDocsByIdClient(code, payload) {
    let header = await BaseWebService.standardHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_CMS}/record/read/advance/template?code=${code}`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);

    return response;
  }

  static async getUploadDocs(code, payload, userId) {
    let header = await BaseWebService.standardHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_CMS}/record/read/advance/template?code=${code}`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);

    return response;
  }

  static async getAllUploadDocs(code, payload) {
    let header = await BaseWebService.standardHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_CMS}/record/read/template?code=${code}`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);

    return response;
  }

  static async getPDFAsset(id) {
    // let header = await BaseWebService.standardHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/asset/${id}`);
    let resp = await axios.get(
      url,
      {
        // headers: header,
        // responseType: 'blob',
      }
    );
    return resp;
  }

  static async saveClientSignatureImage(payload, proposalId, userId) {
    let header = await BaseWebService.standardHeaders();

    header.userId = userId;
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/proposal/submitSignature?proposalId=${proposalId}`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);

    return response;
  }

}

export default DocumentWebService;
